module.exports = __webpack_public_path__ + "static/media/btn7.57e4ef24.svg";